import * as yup from 'yup'

export const ENTRY_ID = '5xGqxZgth5Dh8u9VIOYPkV'

export const fieldNames = ['counselorLed', 'implementationType', 'teacherLed']

export const validationSchema = yup.object().shape({
  implementationType: yup
    .string()
    .nullable()
    .required('Please select an option.'),
  counselorLed: yup
    .boolean()
    .nullable()
    .test('leader-is-required', 'Please select at least one option.', function(
      value,
    ) {
      const { teacherLed } = this.parent
      return !!value || !!teacherLed
    }),
  teacherLed: yup
    .boolean()
    .nullable()
    .test('leader-is-required', 'Please select at least one option.', function(
      value,
    ) {
      const { counselorLed } = this.parent
      return !!value || !!counselorLed
    }),
})
